import type { HTMLAttributes, ReactNode } from 'react';
import { motion } from 'framer-motion';
import { stripConflictProps } from './motion';

interface CardProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  as?: 'article' | 'div' | 'section';
}

export function Card({ children, as: Component = 'article', className = '', ...props }: CardProps) {
  const MotionTag = motion[Component];
  return (
    <MotionTag
      className={`ui-card${className ? ` ${className}` : ''}`}
      whileHover={{ y: -2 }}
      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
      {...stripConflictProps(props)}
    >
      {children}
    </MotionTag>
  );
}
